import { FC } from "react";
import FeatureWrapper from "./components/FeatureWrapper";
import PageContent from "@/pages/PageContent";

const FeatureView: FC = () => {
  return (
    <PageContent title="Features">
      <div className="flex flex-col transition-all gap-4 duration-300 p-4 xl:px-8 h-full">
        <FeatureWrapper />
      </div>
    </PageContent>
  );
};

export default FeatureView;
